export class FieldInsideTab{
	constructor(
		public id : number ,
		public label : string= '',		
		public value : string= '',
		public key : string= '',
	){}
}

export class FieldInsideGroup{
	constructor(
		public id : number ,
		public label : string= '',		
		public value : string= '',
		public key : string= '',
	){}
}


// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/template/create/template.ts